const CONFIG = {
  KEY: '112233',
  BASE_URL: 'https://restaurant-api.dicoding.dev/',
  BASE_IMAGE_URL: 'https://restaurant-api.dicoding.dev/images/medium/',
  DEFAULT_LANGUAGE: 'en-us',
  DB_NAME: 'fav-resto',
  DB_VERSION: 1,
  OBJECT_STORE_NAME: 'resto',
};

export default CONFIG;
